import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'nns-tabs',
  template: `
    <div class="nns-tabs-inner">
      <div class="wrapper" flex layout="row" layout-align="start start">
        <nns-tab-button
          title="NOTE"
          flex layout="row" layout-align="center center"
          icon="note-inv"
          [ngClass]="{'active': activeTab == 1}"
          (click)="selectTab(1)"
        ></nns-tab-button>
        <nns-tab-button
          title="FILES"
          flex layout="row" layout-align="center center"
          icon="attachments-inv"
          [counter]="filesCount"
          [ngClass]="{'active': activeTab == 2}"
          (click)="selectTab(2)"
        ></nns-tab-button>
        <nns-tab-button
          title="TO-DO"
          flex layout="row" layout-align="center center"
          icon="todo-inv"
          [counter]="todosCount"
          [ngClass]="{'active': activeTab == 3}"
          (click)="selectTab(3)"
        ></nns-tab-button>
     </div>
    </div>
  `,
  styles: [`
    .nns-tabs-inner{
      background:#EBEFF1;
      border-bottom:1px solid #cecece;
      width:100%;
    }
    .wrapper {
      max-width:970px;
      min-width:320px;
      margin:0 auto;
      padding:0;
      position:relative;
      box-sizing:border-box;
    }
  `, `
    :host-context(.nns-theme-night) .nns-tabs-inner {
      background:#2F3737;
      border-color:#414B4C;
    }
    :host-context(.nns-theme-night) nns-tab-button {
      color:#fff;
    }
  `]
})
export class TabsComponent implements OnInit {
  @Input() filesCount;
  @Input() todosCount;
  @Output() changeTab = new EventEmitter();
  activeTab = 1;

  ngOnInit() {
    this.emitTab();
  }

  selectTab(tab) {
    this.activeTab = tab;
    this.emitTab();
  }

  emitTab() {
    this.changeTab.emit(this.activeTab);
  }
}
